import React from 'react'
import { useParams } from 'react-router-dom'
import StaticPage from '../components/StaticPage'
import RichHtml from '../components/RichHtml'
import staticPages from '../data/staticPages.json'

/**
 * Renders a migrated static/info article (e.g. Radios, Training) by slug.
 * Content was extracted from the legacy Joomla site into staticPages.json.
 */
function InfoPage({ slug: slugProp }) {
  const params = useParams()
  const slug = slugProp || params.slug
  const page = staticPages[slug]

  if (!page) {
    return (
      <StaticPage title="Page not found">
        <p>Sorry, that page doesn't exist. <a href="/">Return home.</a></p>
      </StaticPage>
    )
  }

  return (
    <StaticPage title={page.title}>
      <RichHtml html={page.html} />
    </StaticPage>
  )
}

export default InfoPage
